module.exports = __webpack_public_path__ + "img/calendar2.a06c7e7b.gif";